import moment from "moment";
import { ConvertUtils } from "./ConvertUtils";

export function getStartEndOfDay(dateTime: string | number | Date) {
  // Check if the input is a Date object
  if (!(dateTime instanceof Date)) {
    throw new Error("Input is not a Date object");
  }

  // Copy the Date object to avoid modifying the original object
  const startDate = new Date(dateTime);
  const endDate = new Date(dateTime);

  // Set hours, minutes, seconds, and milliseconds for the start time
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  startDate.setMilliseconds(0);

  // Set hours, minutes, seconds, and milliseconds for the end time
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  endDate.setMilliseconds(999);

  return { startTime: startDate, endTime: endDate };
}

export function areDatesDifferent(date1: string | number | Date, date2: string | number | Date) {
  // Ép kiểu thành đối tượng Date nếu đầu vào không phải là đối tượng Date
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // So sánh năm, tháng và ngày của hai đối tượng Date
  const isYearEqual = d1.getFullYear() === d2.getFullYear();
  const isMonthEqual = d1.getMonth() === d2.getMonth();
  const isDayEqual = d1.getDate() === d2.getDate();

  // Trả về kết quả kiểm tra sự khác nhau
  return !(isYearEqual && isMonthEqual && isDayEqual);
}

export function convertToUTC(dateTime: { getUTCFullYear: () => number; getUTCMonth: () => number | undefined; getUTCDate: () => number | undefined; getUTCHours: () => number | undefined; getUTCMinutes: () => number | undefined; getUTCSeconds: () => number | undefined; getUTCMilliseconds: () => number | undefined; }) {
  // Kiểm tra xem input có phải là đối tượng Date không
  if (!(dateTime instanceof Date)) {
    throw new Error("Input is not a Date object");
  }

  // Lấy timestamp của ngày giờ hiện tại và chuyển đổi thành UTC
  const utcTimestamp = Date.UTC(
    dateTime.getUTCFullYear(),
    dateTime.getUTCMonth(),
    dateTime.getUTCDate(),
    dateTime.getUTCHours(),
    dateTime.getUTCMinutes(),
    dateTime.getUTCSeconds(),
    dateTime.getUTCMilliseconds()
  );

  // Tạo đối tượng Date mới từ timestamp UTC
  const utcDate = new Date(utcTimestamp);

  return utcDate;
}


export function convertToNetTicks(date: any) {
  return date * 10000 + 621355968000000000;
}

export function dateTimeToTicks(date: any) {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()) * 10000 + 621355968000000000;
}

export function onConvertBetweenDateAndTicks(data: Date | number, isOnlyDate?: boolean): string | number {
  const epochTicks = 621355968000000000;
  const ticksPerMillisecond = 10000;
  const maxDateMilliseconds = 8640000000000000;
  const dateWithTime: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const onlyDate: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
  };
  // ticks to date
  if (typeof data === "number") {
    if (isNaN(data)) {
      return "";
    }
    const ticksSinceEpoch = data - epochTicks;
    const millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;
    if (millisecondsSinceEpoch > maxDateMilliseconds) {
      return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
    }
    const date = new Date(millisecondsSinceEpoch);
    return date.toLocaleDateString("en-US", isOnlyDate ? onlyDate : dateWithTime);
  }
  // date to ticks
  if (Object.prototype.toString.call(data) === "[object Date]" && typeof data !== "string") {
    const ticks = data.getTime() * ticksPerMillisecond + epochTicks;
    return ticks;
  }
  return "";
}

export function convertNetTicksToDateTime(ticks: number): Date {
  return new Date((ticks - 621355968000000000) / 10000);
}

export function convertNetTicksUTCToDateTime(ticks: number): Date {
  const thisDate = new Date((ticks - 621355968000000000) / 10000);
  const offset = thisDate.getTimezoneOffset();
  return new Date(thisDate.getTime() + offset * 60 * 1000);
}

export function convertNetTicksUTCToDateTimeAddSecond(ticks: number): Date {
  const thisDate = new Date((ticks - 621355968000000000) / 10000);
  const offset = thisDate.getTimezoneOffset();
  const convertedDate = new Date(thisDate.getTime() + offset * 60 * 1000);

  if (convertedDate.getMinutes() === 59 && convertedDate.getSeconds() === 59) {
    convertedDate.setSeconds(convertedDate.getSeconds() + 1);
  }

  return convertedDate;
}

export function convertDateStringToDateTime(datetimeString: string): Date {
  const strArr = datetimeString.split("T");
  const dateString = strArr[0].split("-");
  const timeString = strArr[1].split(":");

  const y = parseInt(dateString[0]);
  const m = parseInt(dateString[1]);
  const d = parseInt(dateString[2]);

  const h = parseInt(timeString[0]);
  const ms = parseInt(timeString[1]);
  const s = parseInt(timeString[2]);
  return new Date(y, m - 1, d, h, ms, s);
}

export function getTotalMinutes(date: Date) {
  return date.getHours() * 60 + date.getMinutes();
}

//get time of day in minutes
export function timeOfDayTotalMinutes(dateObj: Date) {
  const hour = dateObj.getHours();
  const minute = dateObj.getMinutes();
  const totalMinute = hour * 60 + minute; //ignore seconds
  return totalMinute;
}

export function dateDiffInMinutes(source: Date, compared: Date) {
  const dateDiffInMiniSeconds = compared.getTime() - source.getTime();
  const miniSecondsInOneMinute = 60 * 1000;
  return dateDiffInMiniSeconds / miniSecondsInOneMinute;
}

export function getDateOnly(dateObj: Date | undefined) {
  if (dateObj) {
    const result = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 0, 0, 0);
    return result;
  }
}

//Add an amount of minutes to a data object
export function addMinutes(dateObj: Date, minutesToAdd: number) {
  const cloneDate = new Date(dateObj.getTime());
  const result = cloneDate.setMinutes(cloneDate.getMinutes() + minutesToAdd);
  return new Date(result);
}

//Add an amount of minutes to a data object
export function addDates(dateObj: Date, datesToAdd: number) {
  const newDate = moment(dateObj).add(datesToAdd, "days")
  return new Date(newDate.toISOString());
}

//Add an amount of years to a data object
export function addYears(dateObj: Date, yearsToAdd: number) {
  const newDate = moment(dateObj).add(yearsToAdd, "years")
  return new Date(newDate.toISOString());
}

//Add an amount of years to a data object
export function addWeeks(dateObj: Date, weeksToAdd: number) {
  const newDate = moment(dateObj).add(weeksToAdd, "weeks")
  return new Date(newDate.toISOString());
}

//Add an amount of months to a data object
export function addMonths(dateObj: Date, monthsToAdd: number) {
  const newDate = moment(dateObj).add(monthsToAdd, "months")
  return new Date(newDate.toISOString());
}

// convert from date in string format "YYYY-MM-DD" to the date time object.
export function StringToDate(dateStr: string) {
  let result: Date = new Date();
  try {
    const splValues = dateStr.split("-");
    if (splValues && splValues.length === 3) {
      const year = ConvertUtils.ToInt(splValues[0]);
      const month = ConvertUtils.ToInt(splValues[1]);
      const date = ConvertUtils.ToInt(splValues[2]);
      // for function new Date(), the month value must be the index (0 = January, 11 = december)
      result = new Date(year, month - 1, date);
    }
  } catch (ex) {
    //console.log(ex);
  }
  return result;
}

// convert from time in string format "THH:mm:ss.mmm" to the date time object.
export function StringToTime(timeStr: string) {
  let result: Date = new Date();
  try {
    const splValues = timeStr.replace("T", "").split(/:|\./);
    if (splValues && splValues.length === 4) {
      const hours = ConvertUtils.ToInt(splValues[0]);
      const minutes = ConvertUtils.ToInt(splValues[1]);
      const seconds = ConvertUtils.ToInt(splValues[2]);
      const miniSeconds = ConvertUtils.ToInt(splValues[3]);
      result = new Date(1970, 1, 1, hours, minutes, seconds, miniSeconds);
    }
  } catch (ex) {
    //console.log(ex);
  }
  return result;
}

export function CloneDateTime(date: Date): Date {
  return new Date(date.getTime());
}

export function CloneDateTimeFromSeparateSource(date: Date, time: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds());
}

// Convert Date to format dd-MM-yyyy
export function DateToString(dateTime: Date): string {
  return dateTime.getDate() + "-" + (dateTime.getMonth() + 1) + "-" + dateTime.getFullYear();
}
